import React from "react"
import { Form, DatePicker, Flex } from "antd"
import { CalendarOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import dayjs from "dayjs"
import { Text } from "ui/Typography"
import { startDateValidate, endDateValidate } from "pagesV2/pro/Calendar/utils"
import styles from "../index.module.css"

/**
 * Date range picker component for start and end dates
 */
const DateRangeFields = () => {
  const { t } = useTranslation()

  // Disable dates before today
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day")
  }

  return (
    <Flex gap={16}>
      <Flex vertical className={styles.fieldWrapper}>
        <Form.Item
          name="startDate"
          label={
            <Text className={styles.fieldLabel}>
              {t("crewMember.scheduledTimeOff.fields.startDate")}
              <span className={styles.required}>*</span>
            </Text>
          }
          required={false}
          rules={[
            { required: true, message: t("crewMember.scheduledTimeOff.validation.startDateRequired") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return startDateValidate(t, getFieldValue("endDate"), value)
              }
            })
          ]}
        >
          <DatePicker
            className={styles.datePicker}
            format="MM/DD/YYYY"
            placeholder={t("crewMember.scheduledTimeOff.placeholders.date")}
            suffixIcon={<CalendarOutlined className={styles.calendarIcon} />}
            disabledDate={disabledDate}
          />
        </Form.Item>
      </Flex>

      <Flex align="center" className="pt-s">
        <Text fw="700">—</Text>
      </Flex>

      <Flex vertical className={styles.fieldWrapper}>
        <Form.Item
          name="endDate"
          label={
            <Text className={styles.fieldLabel}>
              {t("crewMember.scheduledTimeOff.fields.endDate")}
              <span className={styles.required}>*</span>
            </Text>
          }
          required={false}
          rules={[
            { required: true, message: t("crewMember.scheduledTimeOff.validation.endDateRequired") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return endDateValidate(t, getFieldValue("startDate"), value)
              }
            })
          ]}
        >
          <DatePicker
            className={styles.datePicker}
            format="MM/DD/YYYY"
            placeholder={t("crewMember.scheduledTimeOff.placeholders.date")}
            suffixIcon={<CalendarOutlined className={styles.calendarIcon} />}
            disabledDate={disabledDate}
          />
        </Form.Item>
      </Flex>
    </Flex>
  )
}

export default DateRangeFields
